import * as React from "react";
import ModalPopup from "../commons/components/modal/ModalPopup";
import Form from "../commons/components/form/Form";
import SelectInput from "../commons/components/form/input/SelectInput";
import Team from "../commons/model/Team";
import Identity from "../commons/model/Identity";
import Option from "../commons/model/Option";

interface EditUserTeamDialogProps {
  user: Identity;
  teams: Team[];
  close: (reload?: boolean) => any;
  onChange: (teamUid: string) => Promise<any>;
}

export default function EditUserTeamDialog({
  user,
  teams,
  close,
  onChange,
}: EditUserTeamDialogProps) {
  const initialTeam = teams.find((t) => t.users.indexOf(user) > -1);
  return (
    <ModalPopup closeModal={close}>
      <div className="title">{i18n["Dialog.EditUserTeam.Title"]}</div>
      <Form submitLabel={i18n["Global.Save"]} submit={(form) => onChange(form.team.value)}>
        <SelectInput
          name="team"
          initialValue={initialTeam.uid}
          options={teams.map(({ uid, name }) => new Option(uid, name))}
          label={i18n["Dialog.EditUserTeam.Team.Label"]}
        />
      </Form>
    </ModalPopup>
  );
}
